import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'
import { parseJwt } from '../functions/util'
import { usePluginspace } from '../hooks/usePluginspace';

const JWT_SALT = process.env.REACT_APP_JWT_SALT || "ninegridCrypoToken";
export type DecodedTokenData = {
    id: number;
    email: string;
    plugintype: string;
    identifier: string;
    pluginspaceId: number;
    plugintypeId: string;
    profile: string;
    pluginAdm: number;
    expiratedAt: string;
}

type LoginData = {
    accessToken: string
    id?: string | number
    expiratedAt: string
    identifier: string
    email: string
    plugintype: string
    pluginspaceId: number | null
    plugintypeId: string;
    profile: string;
}

type AuthContextData = {
    loginInfo: LoginData
    currentPluginspaceId: number | null;
    setLoginInfo: Dispatch<SetStateAction<LoginData>>;
    logout: () => void;
    verifyPluginSpace: () => boolean;
    getInitialData: () => Promise<DecodedTokenData | undefined>;
}



type AuthContextProvider = {
    children: ReactNode
}
const PLUGINSPACE_CHANGE_EVENT = 'pluginspace:change';

export const AuthContext = createContext({} as AuthContextData)

const AuthProvider = ({ children }: AuthContextProvider) => {
    const { getThisPluginspace } = usePluginspace();
    const [loginInfo, setLoginInfo] = useState<LoginData>({
        accessToken: '',
        expiratedAt: '',
        identifier: '',
        id: '',
        email: '',
        plugintype: '',
        pluginspaceId: null,
        plugintypeId: '',
        profile: '',
    })
    const [currentPluginspaceId, setCurrentPluginspaceId] = useState<number | null>(null)

    const logout = () => {

        localStorage.removeItem('loginInfo')
        setLoginInfo({
            accessToken: '',
            expiratedAt: '',
            identifier: '',
            email: '',
            plugintype: '',
            pluginspaceId: null,
            plugintypeId: '',
            profile: '',
        })

    }

    const isTokenExpired = (expiratedAt?: string) => {
        if (!expiratedAt) return false
        return new Date(expiratedAt).getTime() < Date.now()
    }

    const getInitialData = async () => {
        try {
            let login = localStorage.getItem('loginInfo')

            const pluginspace = await getThisPluginspace()

            if (pluginspace?.id) {
                setCurrentPluginspaceId(pluginspace.id);
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(
                        new CustomEvent(PLUGINSPACE_CHANGE_EVENT, {
                            detail: { pluginspaceId: pluginspace.id },
                        })
                    );
                }
            }

            if (login && typeof login === 'string') {
                const data = JSON.parse(login)
                if (data) {
                    const tkNoSalt = data.split(JWT_SALT).join('');
                    const tk: DecodedTokenData | null = parseJwt(tkNoSalt);

                    if (
                        tk &&
                        pluginspace &&
                        tk.pluginspaceId === pluginspace.id &&
                        !isTokenExpired(tk.expiratedAt)
                    ) {
                        setLoginInfo({
                            accessToken: data,
                            expiratedAt: tk.expiratedAt,
                            id: tk.id,
                            identifier: tk.identifier,
                            email: tk.email,
                            plugintype: tk.plugintype,
                            pluginspaceId: tk.pluginspaceId,
                            plugintypeId: tk.plugintypeId,
                            profile: tk.profile,
                        })
                        return tk
                    } else {
                        logout()
                    }
                } else {
                    logout()
                }
            }
        } catch (error) {
            console.log(error)
            logout()
        }
    }

    const verifyPluginSpace = () => {
        const login = localStorage.getItem('loginInfo_ninegrid_adm');
        if (!login) return false
        const data: LoginData = JSON.parse(login)
        if (data) {
            const tkNoSalt = data.accessToken.split(JWT_SALT).join('');
            const tk: DecodedTokenData | null = parseJwt(tkNoSalt);
            if (tk?.pluginspaceId === 2) {
                return true;
            }
        }
        return false;
    }

    useEffect(() => {
        getInitialData()
    }, [])

    return (
        <AuthContext.Provider
            value={{
                loginInfo,
                currentPluginspaceId,
                setLoginInfo,
                logout,
                verifyPluginSpace,
                getInitialData
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider